var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardRightClick = function SvgKeyboardRightClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.942,
    d: "M1.543 4.633a3.456 3.456 0 1 1 6.911 0v4.225a3.456 3.456 0 1 1-6.911 0V4.634ZM1.906 5.477h6.189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5 1.258 2.63.871.57 3.054H5z"
  })));
};
export default SvgKeyboardRightClick;